<template>
  <div>
    <v-row justify="center">
      <v-col class="text-center">
        <!--<v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">
              Paso 1
              <br />Información General
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">
              Paso 2
              <br />Información Tutores
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              Paso 3
              <br />Información Salud
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="4">
              Paso 4
              <br />Administrativos
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <infoGeneral />

              <v-btn color="success" @click="e1 = 2">Continue</v-btn>

              <v-btn flat>Cancel</v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <infoTutores />

              <v-btn color="primary" @click="e1 = 3">Continue</v-btn>

              <v-btn flat>Cancel</v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-5" color="grey lighten-1" height="200px"></v-card>

              <v-btn color="primary" @click="e1 = 4">Continue</v-btn>

              <v-btn flat>Cancel</v-btn>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card class="mb-5" color="grey lighten-1" height="200px"></v-card>

              <v-btn color="primary" @click="e1 = 1">Continue</v-btn>

              <v-btn flat>Cancel</v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>-->
        <infoGeneral
          class="nuevoAlumno"
          :reset="reset"
          :idalumno="idAlumno"
          :alumno="alumno"
          @infoGeneral:mostrarOcultarDialog="mostrarOcultarDialog"
          @infoGeneral:listarAlumnos="listarAlumnos"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import infoGeneral from "./nuevoAlumno/infoGeneral";
//import infoTutores from "./nuevoAlumno/infoTutores";
export default {
  data() {
    return {
      //e1: 0
    };
  },
  props: ["father", "idAlumno", "alumno", "reset"],
  components: {
    infoGeneral
    //infoTutores
  },
  methods: {
    mostrarOcultarDialog: function() {
      this.$emit("editarCrearAlumno:mostrarOcultarDialog");
    },
    listarAlumnos() {
      this.$emit("editarCrearAlumno:listarAlumnos");
    }
  }
};
</script>

<style scoped>
#contenedorNuevoAlumno {
  width: 100%;
}

.nuevoAlumno {
  padding: 25px;
}
</style>